import React, { useState } from "react";
import { CrossIcon } from "../icons/cross";
import { InquiryIcon } from "../icons/inquiry";
import { motion, AnimatePresence } from "framer-motion";
import Inquiry from "./inquiry";

const Inqueries = () => {
  const [showFrom, setShowForm] = useState(false);

  return (
    <>
      <button
        className="fixed bottom-8 lg:bottom-4 right-4 lg:right-6 z-[9999]"
        onClick={() => setShowForm(!showFrom)}
      >
        <AnimatePresence>
          {showFrom ? (
            <motion.div
              initial={{ rotate: 45 }}
              exit={{ transition: { duration: 0.1 } }}
              animate={{ opacity: 1, rotate: 0 }}
              transition={{ duration: 0.1 }}
              className="p-4 rounded-full bg-primary/80 w-[50px] h-[50px] flex justify-center items-center  hover:scale-[0.7] transition"
            >
              {CrossIcon}
            </motion.div>
          ) : (
            <div className="p-3 rounded-full bg-primary/80 w-[50px] h-[50px] hover:scale-105 transition ">
              {InquiryIcon}
            </div>
          )}
        </AnimatePresence>
      </button>
      <AnimatePresence>
        {showFrom && (
          <motion.div
            initial={{ y: 50 }}
            exit={{ y: 25, opacity: 0, transition: { duration: 0.1 } }}
            animate={{ y: 0 }}
            transition={{ duration: 0.2 }}
            className="absolute bottom-24 lg:bottom-14 lg:right-14 z-[9999] w-[85%] lg:w-auto "
          >
            <Inquiry />
          </motion.div>
        )}
      </AnimatePresence>
    </>
  );
};

export default Inqueries;
